export const MENU_PREFIX_PATH = "/menu";
export const MENU_PATH = `${MENU_PREFIX_PATH}/:userID`;
